import { parseUrl, stringifyUrl } from "query-string";
import {
  PlanCodePeriod,
  PlanSelectorSearchParams,
} from "component-library/src/components/Organisms/Billing/types";
import applicationMap, { CheckoutType } from "services/applicationMap";
import { AddOnCodes, AddOnBaseCode } from "component-library";

export function getCheckoutLink({
  checkoutType = CheckoutType.Renewal,
  planCode,
  addOns,
}: {
  checkoutType?: CheckoutType;
  planCode?: string;
  addOns?: AddOnCodes[] | AddOnBaseCode[];
} = {}) {
  const param = planCode?.includes(PlanCodePeriod.Annual)
    ? PlanCodePeriod.Annual
    : PlanCodePeriod.Monthly;

  const parsedUrl = parseUrl(
    applicationMap.routes.checkout({
      type: checkoutType,
    })
  );

  if (planCode) {
    parsedUrl.query[PlanSelectorSearchParams.PreSelectedPlan] = param;
  }

  if (addOns) {
    parsedUrl.query[PlanSelectorSearchParams.PreSelectedAddOns] = addOns.map(
      (addOn) => addOn
    );
  }

  return stringifyUrl(parsedUrl);
}
